/**
 * Compares the selected date if earlier or beyond from the date provided
 */
export default ({ value }) => {
  let pass = true;
  pass = validateFullName(value);

  return pass;
};

const validateFullName = (value) => {
  const splittedValue = value.split(' ');
  return splittedValue.length >= 2;
};
